import {
  SIMSO_COUNT_ASSIGN_SUCCESS,
  SIMSO_HISTORY_LIST_SUCCESS,
  SIMSO_IMPORT_SUCCESS,
  SIMSO_LIST_SUCCESS,
  SIMSO_NEW_CARE_SUCCESS,
  SIMSO_ONE_SUCCESS,
  SIMSO_UPDATE_FILTER,
  SIMSO_SAVE_SUCCESS,
  SIMSO_UPDATE_HOMEPAGE_FILTER,
  SIMSO_HOMEPAGE_LIST_SUCCESS,
  SIMSO_HOMEPAGE_ONE_SUCCESS,
} from 'src/actions/simso.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

const initState = {
  filter: {
    so_dien_thoai: '',
    loai_sim: {},
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  homepageSimsoFilter: {
    so_dien_thoai: '',
    loai_sim: {},
    homepageSimsoPage: 0,
    homepageSimsoLimit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  total: 0,
  selected: undefined,
  homepageSimsoItems: [],
  homepageSimsoTotal: 0,
  homepageSimsoSelected: undefined,
  temp: [],
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0,
  temp_upgoicuoc: [],
}

const simsoReducer = (state = initState, action) => {
  switch (action.type) {
    case SIMSO_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case SIMSO_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
      }
    }
    case SIMSO_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.data
      }
    }
    case SIMSO_UPDATE_HOMEPAGE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageSimsoFilter !== 'undefined' && state.homepageSimsoFilter) {
        if (action.data.homepageSimsoPage == 'no_update' && typeof state.homepageSimsoFilter.homepageSimsoPage !== 'undefined') action.data.homepageSimsoPage = state.homepageSimsoFilter.homepageSimsoPage;
        if (action.data.homepageSimsoLimit == 'no_update' && typeof state.homepageSimsoFilter.homepageSimsoLimit !== 'undefined') action.data.homepageSimsoLimit = state.homepageSimsoFilter.homepageSimsoLimit;
      }
      return {
        ...state,
        homepageSimsoFilter: action.data,
      }
    }
    case SIMSO_HOMEPAGE_LIST_SUCCESS: {
      return {
        ...state,
        homepageSimsoItems: action.data.homepageSimsoItems,
        homepageSimsoTotal: action.data.homepageSimsoTotal,
      }
    }
    case SIMSO_HOMEPAGE_ONE_SUCCESS: {
      return {
        ...state,
        homepageSimsoSelected: action.data
      }
    }
    case SIMSO_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case SIMSO_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case SIMSO_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case SIMSO_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    case SIMSO_SAVE_SUCCESS: {
      return {
        ...state,
        temp_upgoicuoc: []
      }
    }
    default: {
      return state;
    }
  }
}
export default simsoReducer